import { event } from "jquery";

export const munkarend = {
    calendar: undefined,

    initialView: undefined,

    isAdmin: false,
    showFree: false,

    szuro: "",

    init: function () {
        const token = document.head.querySelector("[name~=csrf-token][content]")?.content;

        this.initialView =  this.whichView($(document).width());

        window.axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': token
        };

        document.addEventListener("DOMContentLoaded", () => {
            this.initCalendar();
        });
        document.querySelector('#szuro').addEventListener("change", this.szuroChanged.bind(this));
        document.querySelector('#savenewmunkarendbtn').addEventListener("click", this.saveEvent.bind(this));
        document.querySelector('#reallyDelete').addEventListener("click", this.reallyDeleteEvent.bind(this));
        document.querySelector('#reallyRemove').addEventListener("click", this.reallyRemoveDays.bind(this));
        document.querySelector('#reallyExtend').addEventListener("click", this.extendEventSave.bind(this));
        
        // Worker selection buttons - use event delegation since they're dynamically loaded
        document.body.addEventListener('click', (e) => {
            const target = e.target.closest('button[id^="munkarend"]');
            if (!target) return;
            
            if (target.id === 'munkarendSelectAll') {
                this.selectAllMunkarendDolgozok();
            } else if (target.id === 'munkarendReverseAll') {
                this.reverseMunkarendDolgozok();
            } else if (target.id === 'munkarendDeselectAll') {
                this.deselectAllMunkarendDolgozok();
            }
        });
        document.querySelector('#modifyEditorReverse').addEventListener("click", this.reverseDates.bind(this));


        const dateSelector = document.getElementById('dateEditor');
        if (dateSelector) {
            dateSelector.addEventListener('change', this.EditorDateChanged);
        }

    },

    whichView: function(width) {
        let view;
        if (width < 601) {
          view =  'timeGridDay';
        } else {
          view = 'dayGridMonth';
        }

        window.munkarend.munkarend.initialView = view;
        return view;

      },

    tmpLogEvent: function (event) {
        console.log(event);
    },

    szuroChanged: function (e) {
        console.log("szc", e.target.value);
        window.munkarend.munkarend.szuro = e.target.value;
        window.munkarend.munkarend.calendar.refetchEvents();
    },

    initCalendar: async function () {
        const that = this;
        const calendarHolder = document.getElementById('mrcalendar');
        if (!calendarHolder) { return; }

        const elMain = document.querySelector("main");
        const elNav = document.querySelector("nav#app-navbar");
        const navH = elNav.clientHeight + 1;

        const newStyleTxt = `calc(100vh - ${navH}px)`;
        elMain.style.height = newStyleTxt;

        //"munkarendAjaxGetAdmin"
        const isAdminResponse = await axios.get(`${document.location.href}AjaxFrontendFlags`);
        //console.log(isAdminResponse);
        this.isAdmin = isAdminResponse?.data?.isAdmin;
        this.showFree = isAdminResponse?.data?.showFreeSlots;

        const startButtons = `dayGridMonth,timeGridWeek,timeGridDay${this.isAdmin ? ',custom1 jelentesBtn tableBtn' : ''}`;
        const endButtons = `${this.isAdmin ? 'custom2 ' : ''}prevYear,prev,next,nextYear`;

        this.calendar = new window.Calendar(calendarHolder, {
            height: '100%',
            themeSystem: 'bootstrap',
            plugins: [window.dayGridPlugin, window.timeGridPlugin, window.listPlugin, window.timeGridPlugin, window.bootstrapPlugin],
            selectable: true,
            timeZone: 'CET',
            eventDidMount: function (info) {
                const icon = info?.event?.allDay ? '<i class="fas fa-calendar-day"></i>' : '<i class="fas fa-clock"></i>';
                const workerCount = info.event.extendedProps.workerCountDisplay 
                    ? `<span class="worker-count badge badge-info ml-1">${info.event.extendedProps.workerCountDisplay}</span>` 
                    : '';
                const carBadge = info.event.extendedProps.car_label
                    ? `<span class="car-badge badge badge-secondary ml-1">${info.event.extendedProps.car_label}</span>`
                    : '';
                $(info.el).find('.fc-event-title').prepend(`${icon}&nbsp;` ).append(workerCount).append(carBadge);
                
                const workerCountInfo = info.event.extendedProps.workerCountDisplay 
                    ? `<div class="worker-count-info"><strong>Dolgozók:</strong> ${info.event.extendedProps.workerCountDisplay}</div>` 
                    : '';
                const carInfo = info.event.extendedProps.car_label
                    ? `<div class="car-info"><strong>Autó:</strong> ${info.event.extendedProps.car_label}</div>`
                    : '';
                const toolTipStr = `
                    <div class="feladatToolTip">
                        ${workerCountInfo}
                        ${carInfo}
                        <div class="feladat">${info.event.extendedProps.napifeladat}</div>
                        <div class="csapattagok">${info.event.extendedProps.users}</div>
                    </div>
                `;
                tippy(info.el, {
                    content: toolTipStr,
                    allowHTML: true,
                });
                if (info.event.id != -1 && window.munkarend.munkarend.isAdmin) {
                    info.el.addEventListener('dblclick', () => {
                        window.munkarend.munkarend.editEvent(info.event, true);
                    });
                    info.el.addEventListener("contextmenu", (jsEvent) => {
                        jsEvent.preventDefault()

                        const items = [
                            {
                                label: "Törlés",
                                iconClass: "fas fa-trash text-danger",
                                callback: (e) => {
                                    window.munkarend.munkarend.deleteEvent(info);

                                },
                            },
                            "hr",
                            {
                                label: "Másolás",
                                iconClass: "fas fa-copy text-primary",
                                callback: (e) => {
                                    window.munkarend.munkarend.editEvent(info.event, false);
                                },
                            },
                            {
                                label: "Kiterjesztés",
                                iconClass: "fas fa-arrow-alt-circle-right text-primary",
                                callback: (e) => {
                                    window.munkarend.munkarend.extendEvent(info.event);

                                },
                            },
                            {
                                label: "Szétvágás",
                                iconClass: "fas fa-cut text-primary",
                                callback: (e) => {
                                    window.munkarend.munkarend.removeDays(info);
                                },
                            },
                            "hr",
                            {
                                label: "Szerkesztés",
                                iconClass: "fas fa-edit text-primary",
                                callback: (e) => {
                                    window.munkarend.munkarend.editEvent(info.event, true);
                                },
                            },
                        ];

                        new VanillaContextMenu({
                            scope: info.el,
                            menuItems: items
                          });

                    });
                }
            },

            initialView: this.initialView,
            eventBorderColor: 'white',
            headerToolbar: {
                start: startButtons,
                center: 'title',
                end: endButtons
            },
            customButtons: {
                custom1: {
                    text: 'Szabad dolgozók mutatása',
                    bootstrapFontAwesome: "fas fa-user-tag",
                    click: function () {
                        window.munkarend.munkarend.showFree = !window.munkarend.munkarend.showFree;
                        const btn = document.querySelector('.fc-custom1-button');
                        if (btn) {
                            btn.setAttribute('aria-pressed', window.munkarend.munkarend.showFree);
                            if (window.munkarend.munkarend.showFree) {
                                btn.classList.add('active');
                            } else {
                                btn.classList.remove('active');
                            }
                        }
                        window.munkarend.munkarend.calendar.refetchEvents();
                    }
                },
                jelentesBtn: {
                    text: 'Jelentések',
                    bootstrapFontAwesome: "far fa-file-alt",
                    click: function (e) {
                        document.location = `${document.location.href}Jelentes`;
                    }
                },
                tableBtn: {
                    text: 'Táblázatos lista',
                    bootstrapFontAwesome: "fa-solid fa-table-list",
                    click: function (e) {
                        document.location = `${document.location.href}Tabla`;
                    }
                },
                custom2: {
                    text: 'Új létrehozása',
                    bootstrapFontAwesome: "fas fa-plus-circle",
                    click: () => {
                        $('#editorDateGroup').hide();
                        $('#datumSelectorEditor').show();
                        $('#csapatEditorModalLabel').html('Munkarend létrehozása');
                        this.clearEvent();
                        $('#csapatEditorModal').modal('show');
                    }
                }
            },

            viewDidMount: function(info) {
                document.querySelectorAll('.fc-header-toolbar button').forEach((button) => {
                  if(button.classList.contains('fc-custom1-button')) {
                    button.classList.remove('btn-primary');
                    button.classList.add('btn-success');
                    button.setAttribute('aria-pressed', window.munkarend.munkarend.showFree);
                    if (window.munkarend.munkarend.showFree) {
                        button.classList.add('active');

                    }
                  }
                  if(button.classList.contains('fc-jelentesBtn-button')) {
                    button.classList.remove('btn-primary');
                    button.classList.add('btn-secondary');
                  }
                  if(button.classList.contains('fc-tablaBtn-button')) {
                    button.classList.remove('btn-primary');
                    button.classList.add('btn-secondary');
                  }
                });
              },

            events:{
                url: `${document.location.href}Ajax`,
                extraParams: function() { // a function that returns an object
                    return {
                      showFreeSlots: window.munkarend.munkarend.showFree,
                      szuro: window.munkarend.munkarend.szuro
                    };
                  }
            },
            _events: `${document.location.href}Ajax`,
            firstDay: 1,
            slotMinTime: '06:00:00',
            locale: window.huLocale,
            eventClick: info => { this.openEvent(info) },
            select: info => { console.log(info) }
        });

        this.calendar.render();
    },
    EditorDateChanged: function (e) {
        const date = e.target.value;
        if (!date) {
            return;
        }
        const outer = document.querySelector('#dolgozokOuter');

        let originalState = [];

        if (window.savedDolgozoLista) {
            originalState = window.savedDolgozoLista.map(dolgozo => {
                return {
                    id: dolgozo,
                    checked: true,
                }
            });
            window.savedDolgozoLista = undefined;
        } else {
            originalState = Array.from(outer.querySelectorAll('input[type=checkbox]')).map(chkbox => {
                return {
                    id: parseInt(chkbox.id.split('_')[1], 10),
                    checked: chkbox.checked,
                };
            });
        }

        const editedId = document.querySelector('#id').value;

        axios.get(`${document.location.href}DolgozokForDate?date=${encodeURIComponent(date)}&currentEdited=${editedId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            const dolgozok = response.data;

            outer.innerHTML = '';
            
            // Split dolgozok into two columns
            const midpoint = Math.ceil(dolgozok.length / 2);
            const column1 = dolgozok.slice(0, midpoint);
            const column2 = dolgozok.slice(midpoint);
            
            const generateCheckbox = (dolgozo) => {
                const disabledStyle = !dolgozo.enabled ? 'style="opacity: 0.4;"' : '';
                return `<div class="form-check" ${disabledStyle}>
                        <input class="form-check-input form-check-dolgozo" type="checkbox" value="1" id="dolgozo_${dolgozo.id}" ${!dolgozo.enabled ? 'disabled' : ''} ${dolgozo.enabled && originalState.find(a => a.id === dolgozo.id)?.checked ? 'checked' : ''}>
                        <label class="form-check-label" for="dolgozo_${dolgozo.id}">${dolgozo.name}</label>
                    </div>`;
            };
            
            let newInnerHtml = `<div class="row">
                <div class="col-6">
                    ${column1.map(generateCheckbox).join('')}
                </div>
                <div class="col-6">
                    ${column2.map(generateCheckbox).join('')}
                </div>
            </div>`;
            
            outer.innerHTML = newInnerHtml;
        })
            .catch(function (error) {
                const errorMessage = error?.response?.data?.message || 'Ismeretlen hiba történt!';
                window.toastr.error(errorMessage);
            });

            if (!editedId) {
                window.munkarend.munkarend.loadCarsForSelection(date, null, window.savedCarList);
            }
    },

        loadCarsForSelection: function (date, days, selectedCars) {
            const carOuter = document.querySelector('#carsOuter');
            if (!carOuter) {
            return;
        }

        const editedId = document.querySelector('#id').value;
        let url = `${document.location.href}CarsForDate?currentEdited=${encodeURIComponent(editedId)}`;
        if (days && Array.isArray(days) && days.length > 0) {
            url += `&days=${encodeURIComponent(days.join(','))}`;
        } else if (date) {
            url += `&date=${encodeURIComponent(date)}`;
        } else {
            carOuter.innerHTML = '';
            return;
        }

        axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            const cars = response.data;
            const savedCars = selectedCars ?? window.savedCarList ?? [];

            const generateCheckbox = (car) => {
                const disabledStyle = !car.enabled ? 'style="opacity: 0.4;"' : '';
                const checked = savedCars.includes(car.id) ? 'checked' : '';
                const disabled = !car.enabled ? 'disabled' : '';
                return `<div class="form-check" ${disabledStyle}>
                        <input class="form-check-input form-check-car" type="checkbox" value="1" id="car_${car.id}" ${disabled} ${checked}>
                        <label class="form-check-label" for="car_${car.id}">${car.label}</label>
                    </div>`;
            };

            carOuter.innerHTML = `<div class="row">
                <div class="col-6">
                    ${cars.filter((_, i) => i % 2 === 0).map(generateCheckbox).join('')}
                </div>
                <div class="col-6">
                    ${cars.filter((_, i) => i % 2 === 1).map(generateCheckbox).join('')}
                </div>
            </div>`;

            window.savedCarList = undefined;
        }).catch(function (error) {
            const errorMessage = error?.response?.data?.message || 'Ismeretlen hiba történt!';
            window.toastr.error(errorMessage);
        });
    },

    clearEvent: function() {
        document.querySelector('#id').value = '';
        document.querySelector('#nev').value = '';
        document.querySelector('#color').value = '';
        document.querySelector('#dateEditor').value ='';
        document.querySelector('#feladat').value = '';
        document.querySelector('#dolgozokOuter').innerHTML = '';
        const carOuter = document.querySelector('#carsOuter');
        if (carOuter) {
            carOuter.innerHTML = '';
        }
    },

    editEvent: async function (event, bisEdit) {
        console.log(event);
        this.clearEvent();

        if (bisEdit) {
            $('#editorDateGroup').show();
            $('#datumSelectorEditor').hide();
        } else {
            $('#editorDateGroup').hide();
            $('#datumSelectorEditor').show();
        }

        if (bisEdit) {
            document.querySelector('#id').value = event.id;
        }
        document.querySelector('#nev').value = event.title;
        document.querySelector('#color').value = event.backgroundColor;
        document.querySelector('#dateEditor').value = event.start.toISOString().slice(0, 10);
        document.querySelector('#startEditor').value = event.extendedProps.customstartTime;
        document.querySelector('#endEditor').value = event.extendedProps.customendTime;
        document.querySelector('#feladat').value = event.extendedProps.napifeladatOriginal;
        window.savedDolgozoLista = event.extendedProps.usersids;
        window.savedCarList = event.extendedProps.car_ids || [];
        $('#csapatEditorModalLabel').html('Munkarend módosítása');
        $('#csapatEditorModal').modal('show');
        setTimeout(() =>{
            const dateSelector = document.getElementById('dateEditor');
            const e = new Event("change");
            dateSelector.dispatchEvent(e);
        }, 300);

        //Dátumok leszedése
        axios.get(`${document.location.href}EventDates?event=${encodeURIComponent(event.id)}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            const outer = document.querySelector('#editorDateUl');
            const datumok = response.data;

            outer.innerHTML = '';
            let newInnerHtml = datumok.map(datum => {
                return `<li>
                            <a class="dropdown-item" href="javascript:void(null)">
                                <div class="form-check">
                                    <input class="form-check-input form_edit_checkdate" type="checkbox" value="${datum}"
                                        id="form_edit_checkdate__${datum}" checked />
                                    <label class="form-check-label" for="form_edit_checkdate__${datum}">${datum}</label>
                                </div>
                            </a>
                        </li>`;
            }).join('');
            outer.innerHTML = newInnerHtml;

            window.munkarend.munkarend.loadCarsForSelection(null, datumok, window.savedCarList);

            document.querySelectorAll('.form_edit_checkdate').forEach((checkbox) => {
                checkbox.addEventListener('change', () => {
                    const selectedDays = Array.from(document.querySelectorAll('.form_edit_checkdate'))
                        .filter(chkbox => chkbox.checked)
                        .map(chkbox => chkbox.id.split('__')[1]);
                    window.munkarend.munkarend.loadCarsForSelection(null, selectedDays, window.savedCarList);
                });
            });
        }).catch(function (error) {
            const errorMessage = error?.response?.data?.message || 'Ismeretlen hiba történt!';
            window.toastr.error(errorMessage);
        });

    },

    reverseDates: function() {
        Array.from(document.querySelectorAll('.form_edit_checkdate')).forEach(chkbox => chkbox.checked = !chkbox.checked);
    },

    openEvent: async function (info) {
        console.log(info);
        const id = info.event.id;
        try {
            const response = "";
        } catch (err) {
            console.log(err);
        }
    },

    extendEvent: function (info) {
        const dateInput = document.querySelector('#dateEditorExtend');
        const eventDate = info.start.toISOString().slice(0, 10);
        document.querySelector('#extendId').value = info.id;
        dateInput.value = eventDate;
        dateInput.setAttribute("min", eventDate);
        $('#extendModal').modal('show');
    },

    extendEventSave: async function() {
        const form = document.querySelector('#extendFeladatForm');
        form.classList.remove('was-validated');
        const validationResult = form.checkValidity();
        if (!validationResult) {
            form.classList.add('was-validated');
            toastr.error('A kiterjesztés nem menthető, ellenőrizze a hibákat!');
            return;
        }
        const id = document.querySelector('#extendId').value;
        const date = document.querySelector('#dateEditorExtend').value;

        const body = { date }

        try {
            const response = await axios.post(`${document.location.href}Extend?id=${encodeURIComponent(id)}`, {
                headers: { 'Content-Type': 'application/json' },
                data: body
            });
            toastr.success(response.data.message);
            document.querySelector('#extendFeladatForm').reset()
            $('#extendModal').modal('hide');
            this.calendar.refetchEvents();
        } catch (err) {
            const localErr = err;
            const errorMessage = localErr?.response?.data?.message ?? 'Ismeretlen szerveroldali hiba történt!';
            toastr.error(errorMessage);
        }

    },

    removeDays: async function(info) {
        document.querySelector('#removeDaysId').value = info.event.id;
        $('#removeDaysModal').modal('show');


        axios.get(`${document.location.href}EventDates?event=${encodeURIComponent(info.event.id)}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            const outer = document.querySelector('#removeDatesHolder');
            const datumok = response.data;

            outer.innerHTML = '';
            let newInnerHtml = datumok.map(datum => {
                return `<div class="form-check">
                        <input class="form-check-input form-check-datumremove" type="checkbox" value="1" id="removeDay_${datum}" >
                        <label class="form-check-label" for="removeDay_${datum}">${datum}</label>
                    </div>`;
            }).join('');
            outer.innerHTML = newInnerHtml;
        }).catch(function (error) {
            const errorMessage = error?.response?.data?.message || 'Ismeretlen hiba történt!';
            window.toastr.error(errorMessage);
        });
    },

    reallyRemoveDays: async function() {
        const datumok = Array.from(document.querySelectorAll('.form-check-datumremove')).filter(chkbox => chkbox.checked).map(chkbox => chkbox.id.split('_')[1]).sort().join(',');
        if (datumok.length === 0) {
            window.toastr.warning('Nincs kijelölt dátum');
            return;
        }
        const id = document.querySelector('#removeDaysId').value;

        const body = { datumok };
        try {
            const response = await axios.post(`${document.location.href}RemoveDays?id=${encodeURIComponent(id)}`, {
                headers: { 'Content-Type': 'application/json' },
                data: body
            });
            toastr.success(response.data.message);
            this.calendar.refetchEvents();
            $('#removeDaysModal').modal('hide');
        } catch (err) {
            const localErr = err;
            const errorMessage = localErr?.response?.data?.message ?? 'Ismeretlen szerveroldali hiba történt!';
            toastr.error(errorMessage);
        }


    },

    deleteEvent: async function (info) {
        window.eventToDelete = info.event.id;
        $('#confirmDeleteModal').modal('show');


        axios.get(`${document.location.href}EventDates?event=${encodeURIComponent(info.event.id)}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            const outer = document.querySelector('#deleteDatesHolder');
            const datumok = response.data;

            outer.innerHTML = '';
            let newInnerHtml = '<ul>' + datumok.map(datum => `<li>${datum}</li>`).join('') + '</ul>';
            outer.innerHTML = newInnerHtml;
        }).catch(function (error) {
            const errorMessage = error?.response?.data?.message || 'Ismeretlen hiba történt!';
            window.toastr.error(errorMessage);
        });
    },

    reallyDeleteEvent: async function() {
        const eventId = window.eventToDelete;
        if (!eventId) {
            return;
        }
        try {
            const response = await axios.delete(`${document.location.href}Remove`, {
                headers: { 'Content-Type': 'application/json' },
                data: { eventId}
            });
            toastr.success(response.data.message);
            this.calendar.refetchEvents();
            $('#confirmDeleteModal').modal('hide');
        } catch (err) {
            const localErr = err;
            const errorMessage = localErr?.response?.data?.message ?? 'Ismeretlen szerveroldali hiba történt!';
            toastr.error(errorMessage);
        }
    },

    saveEvent: async function () {
        //nev,color,dateEditor,feladat
        const form = document.querySelector('#ujfeladatform');
        form.classList.remove('was-validated');
        const validationResult = form.checkValidity();
        if (!validationResult) {
            form.classList.add('was-validated');
            toastr.error('A munkarend nem menthető, ellenőrizze a hibákat!');
            return;
        }
        const id = document.querySelector('#id').value;
        const nev = document.querySelector('#nev').value;
        const color = document.querySelector('#color').value;
        const dateEditor = document.querySelector('#dateEditor').value;
        const startEditor = document.querySelector('#startEditor').value;
        const endEditor = document.querySelector('#endEditor').value;
        const feladat = document.querySelector('#feladat').value;
        const carIds = Array.from(document.querySelectorAll('.form-check-car'))
            .filter(chkbox => chkbox.checked)
            .map(chkbox => chkbox.id.split('_')[1])
            .sort()
            .join(',');
        const dolgozok = Array.from(document.querySelectorAll('.form-check-dolgozo')).filter(chkbox => chkbox.checked).map(chkbox => chkbox.id.split('_')[1]).sort().join(',');
        let days;
        if (id) {
            days = Array.from(document.querySelectorAll('.form_edit_checkdate')).filter(chkbox => chkbox.checked).map(chkbox => chkbox.id.split('__')[1]).sort().join(',');
        }

        if (!dolgozok) {
            toastr.error('Legalább egy dolgozó választása kötelező!');
            return;
        }
        const body = { id, nev, color, dateEditor, startEditor, endEditor, feladat, dolgozok, days, car_ids: carIds };
        try {
            const response = await axios.post(`${document.location.href}Save`, body);
            toastr.success(response.data.message);
            document.querySelector('#ujfeladatform').reset()
            $('#csapatEditorModal').modal('hide');
            this.calendar.refetchEvents();
        } catch (err) {
            const localErr = err;
            const errorMessage = localErr?.response?.data?.message ?? 'Ismeretlen szerveroldali hiba történt!';
            toastr.error(errorMessage);
        }
    },

    selectAllMunkarendDolgozok: function() {
        // Only select checkboxes that are not disabled (available workers)
        Array.from(document.querySelectorAll('#dolgozokOuter input[type="checkbox"].form-check-dolgozo:not([disabled])')).forEach(el => {
            el.checked = true;
        });
    },

    reverseMunkarendDolgozok: function() {
        // Only toggle checkboxes that are not disabled (available workers)
        Array.from(document.querySelectorAll('#dolgozokOuter input[type="checkbox"].form-check-dolgozo:not([disabled])')).forEach(el => {
            el.checked = !el.checked;
        });
    },

    deselectAllMunkarendDolgozok: function() {
        // Only deselect checkboxes that are not disabled (available workers)
        Array.from(document.querySelectorAll('#dolgozokOuter input[type="checkbox"].form-check-dolgozo:not([disabled])')).forEach(el => {
            el.checked = false;
        });
    }

};
